import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';
@Injectable({
  providedIn: 'root'
})
export class SalaryAdvanceService {
  private url: string = environment.url;

  constructor(public http: HttpClient) {}

  /**
   * Unblock advance salary benefit
   * @param id of service
   */
  unBlockAdvanceSalary(id: string): Observable<{ requestId: string }> {
    const data = {
      Status: 1
    };
    return this.http.patch<{ requestId: string }>(`${this.url}/services/${id}`, data);
  }
}
